module.exports = __webpack_public_path__ + "img/ldi.761d5690.png";